const actions = {
    FETCH_IT_COMPONENTS: 'FETCH_IT_COMPONENTS',
    FETCH_IT_COMPONENT: 'FETCH_IT_COMPONENT',
    RESET_IT_COMPONENT: 'RESET_IT_COMPONENT',
    RESET_IT_COMPONENTS: 'RESET_IT_COMPONENTS',
    FETCH_IP_ADDRESSES: 'FETCH_IP_ADDRESSES',
    RESET_IP_ADDRESSES: 'RESET_IP_ADDRESSES',

    fetchITComponentsAction: (data) => {
        return {
            type: actions.FETCH_IT_COMPONENTS,
            data: data
        };
    },

    resetITComponentFormAction: () => {
        return {
            type: actions.RESET_IT_COMPONENT,
            data: null
        };
    },
    resetITComponentsFormAction: () => {
        return {
            type: actions.RESET_IT_COMPONENTS,
            data: null
        };
    },

    fetchITComponentAction: (data) => {
        return {
            type: actions.FETCH_IT_COMPONENT,
            data: data
        };
    },

    fetchIPAddressesAction: (data) => {
        return {
            type: actions.FETCH_IP_ADDRESSES,
            data: data
        };
    },
    resetIPAddressesFormAction: () => {
        return {
            type: actions.RESET_IP_ADDRESSES,
            data: null
        };
    },
}

export default actions;
